import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFitnessHeartRate = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.651,5.357A5.7,5.7,0,0,0,13.566,3.9L12,5.329,10.434,3.9a5.7,5.7,0,0,0-9.085,1.46,5.579,5.579,0,0,0,1.063,6.486L12,21.75l9.588-9.907A5.579,5.579,0,0,0,22.651,5.357Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.25,10.5H8.018a.376.376,0,0,1,.336.207l1.773,3.546a.375.375,0,0,0,.683-.028l2.38-5.95a.375.375,0,0,1,.683-.028L14.9,10.293a.376.376,0,0,0,.336.207H18.75",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgFitnessHeartRate;
